import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { PortHomeComponent } from './port-home.component';

const routes: Routes = [
  {
    path: '',
    component: PortHomeComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class PortHomeRoutingModule {}
